import Scroll from './scroll.vue';

export default Scroll;



// WEBPACK FOOTER //
// ./src/components/scroll/index.js